module.exports = __webpack_public_path__ + "static/media/graduation-cap.a1f0b5b9.svg";